import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pla-how-to-save-money',
  templateUrl: './how-to-save-money.component.html',
  styleUrls: ['./how-to-save-money.component.scss']
})
export class HowToSaveMoneyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
